import React, { useCallback } from 'react';

import Box from '@material-ui/core/Box';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Link from '@material-ui/core/Link';

import SigninForm from 'pages/signin/signin-form';

export default function SigninContent({
  courseName,
  role,
  onTransition,
  email,
}) {
  const handleClick = useCallback(() => {
    onTransition instanceof Function && onTransition('signup');
  }, [onTransition]);

  const roleName = {
    student: 'a student',
    staff: 'a staff member',
    instructor: 'an instructor',
  }[role];

  return (
    <>
      <DialogTitle>Accept invitation</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>
          You were invited to enroll in {courseName} as {roleName}.
        </DialogContentText>

        <DialogContentText>
          Log in to your My Digital Hand account below to finish enrolling in
          the course.
        </DialogContentText>

        <DialogContentText>
          If this is your first time,{' '}
          <Link component="button" variant="body1" onClick={handleClick}>
            create an account instead
          </Link>{' '}
          to complete enrollment.
        </DialogContentText>

        <Box mb={1}>
          <SigninForm hideReset hideSignup email={email} />
        </Box>
      </DialogContent>
    </>
  );
}
